/** Invokes callbacks immediately and contains both synchronous and async failures. */
export const runSocketCallback = async (
  callback: () => unknown,
  onError?: (error: unknown) => unknown,
): Promise<void> => {
  try {
    await callback();
  } catch (error) {
    if (!onError) {
      console.error('WebSocket callback failed:', error);
      return;
    }

    try {
      await onError(error);
    } catch (reportingError) {
      console.error('WebSocket error handler failed:', reportingError);
    }
  }
};